import { watch, type App } from "vue";
import { useRouter } from '@library/Services';
import { useJupiterProps } from ".";
import type { IJupiterAppProps } from "@/modules/Jupiter";

export function useJupiterRouteHandler()
{

    return {

        install: async ( app: App ) =>
        {

            const router = useRouter();
            const jupiterProps = useJupiterProps();

            watch( () => router.current.value.path, async ( path: string ) =>
            {

                // Vue router must be awaited to ensure the route table has fully loaded
                await router.vueRouter.isReady();

                // Get the current route query
                const query = router.current.value.query as IJupiterAppProps;

                // Merge the current route params with the state of the jupiter props.  This
                // ensures that the route params are present on every navigation.
                const normalisedQuery = { ...query, ...jupiterProps.getQuery() };
                router.vueRouter.replace( { query: normalisedQuery } );

            }, { immediate: true } );
            
        }

    };
}